export default __webpack_public_path__ + "static/1-36180268f7763d6fdd1ac05b8e0dae4e.png";